'use client'
import { Footer } from "../components/common/Footer2";
import ProjectsOverview from "../components/common/projects/ProjectsOverview";
import { QuickLinkBox } from "../components/common/QuickLinkBox";

export default function Projects() {
  return (
    <>
      <ProjectsOverview></ProjectsOverview>
      <QuickLinkBox></QuickLinkBox>
      <Footer></Footer>
    </>
  );
}
